'use client';

import { createPortal } from 'react-dom';
import styles from './AuthPromptModal.module.css';

interface AuthPromptModalProps {
  title: string;
  message: string;
  onClose: () => void;
}

export default function AuthPromptModal({ title, message, onClose }: AuthPromptModalProps) {
  if (typeof window === 'undefined') return null;

  return createPortal(
    <div
      className={styles.overlay}
      onClick={(e) => {
        e.stopPropagation(); // 👈 блокируем всплытие
        onClose();
      }}
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()} // 👈 клики внутри модалки не закрывают её
      >
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.text}>{message}</p>
        <a href="/auth/signin" className={styles.button}>Sign In</a>
      </div>
    </div>,
    document.body
  );
}
